import React from 'react';
import { TextInput } from '../../../../../../components/textInput/textInput';

interface NotesProps {
  label: string;
  keyValue: string;
  data?: string;
  onSave: (key: string, value: string) => void;
  disabled?: boolean;
  fullWidth?: boolean;
}

export function Notes({
  label,
  keyValue,
  onSave,
  data,
  disabled,
  fullWidth,
}: NotesProps) {
  const saveAnswersResponse = (key: string, value: string) => {
    onSave(key, value);
  };

  return (
    <TextInput
      name={label}
      type="text"
      value={data || ''}
      label={label}
      onChange={(event) => {
        saveAnswersResponse(keyValue, event.target.value);
      }}
      disabled={disabled}
      fullWidth={fullWidth}
      multiline
      rows={2}
    />
  );
}
